/*
 * Module for strength gauge
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicExampleModal/strengthGauge/strengthGaugeView",
  "modules/topicsSplit/topic/topicExampleModal/strengthGauge/strengthGaugeModel",
], function (Marionette, Messenger, StrengthGaugeView, StrengthGaugeModel) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "strengthGauge";
      this.lastEvaluatedExample = null;
      this._setUpVents();
    },
    show: function (example) {
      this.exampleModel = example; //keep track of the example we are editing, so that we don't try comparing it against itself
      //get the topic model
      this.topic = Messenger.reqres.request("current:topic");
      this.strengthModel = new StrengthGaugeModel.strengthGaugeModel();
      this.view = new StrengthGaugeView.strengthGaugeView({ model: this.strengthModel });
      this.showRegion(this.view);
    },
    _buildExampleString: function (example) {
      let exampleString = "";
      example.each(function (entry) {
        exampleString += entry.get("surfaceForm") + " ";
      }, this);
      exampleString = exampleString.trimStrict();
      return exampleString;
    },
    //check if example has been changed.  Only consider surface form string, not substitutions or optionals
    _isExampleChanged: function (oldExampleString, newExampleString) {
      //if the old example is null and the new example is not, then they are obviously different
      if (oldExampleString === null) {
        return newExampleString !== null;
      }
      return oldExampleString.toLowerCase() !== newExampleString.toLowerCase();
    },
    _setUpVents: function () {
      //event to update the strength gauge.  It is passed the collection of example entries to evaluate the strength of.
      Messenger.vent.on(
        "update:strength",
        function (exampleEntries, options) {
          //first, build example String from example collection
          const exampleString = this._buildExampleString(exampleEntries);
          //check if there have been any differences in the example between the last time a strength was checked
          const isChange = this._isExampleChanged(this.lastEvaluatedExample, exampleString);
          if (isChange || (options && options.closing)) {
            this.strengthModel.calculateStrength(
              exampleString,
              this.topic,
              this.exampleModel,
              options,
            );
            //update last example variable
            this.lastEvaluatedExample = exampleString;
          } else {
            //create update event to notify any listeners of the score change (even though no change was made)
            Messenger.vent.trigger("strength:updated", this.strengthModel.get("strength"), options);
          }
        },
        this,
      );
    },
  });
});
